import { Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services';
import { ACCOUNT_STATUS } from '../models/user';
@Injectable({
  providedIn: 'root'
})
export class CorporateAccountOnboardingGuard implements CanLoad, CanActivate {
  constructor(private router: Router, @Optional() private auth: AuthService) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.auth.authenticated();
    if (user && (!user.business)) {
      return true;
    }
    (user && (user.id || user._id) && user.account_status === ACCOUNT_STATUS.APPROVED) ? this.router.navigate([`/corporate-account`]) : this.router.navigate([`/setup/verification`])
    return false
  }

  async canLoad(
    route: Route,
    segments: UrlSegment[]): Promise<boolean> {
    const user = await this.auth.authenticated();
    if (user && (!user.business)) {
      return true;
    }
    (user && (user.id || user._id) && user.account_status === ACCOUNT_STATUS.APPROVED) ? this.router.navigate([`/corporate-account`]) : this.router.navigate([`/setup/verification`])
    return false
  }

}
